import React, {Component} from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import eo from 'date-fns/locale/eo';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
registerLocale('en-gb', eo);

class Datepicker extends Component {
  render() {
    const {getStartDate, handleChange, getExcludeDates, today, numberDatepicker, handleDateChangeRaw} = this.props;

    const isWeekday = date => {
      const day = moment(date).day();
      return day !== 0;
    };

    return (
      <div>
        <DatePicker
          locale="en-gb"
          selected={getStartDate(numberDatepicker)}
          onChange={(date) => handleChange(numberDatepicker, date)}
          excludeDates={getExcludeDates}
          minDate={moment().add(3, 'days').toDate()}
          dateFormat="dd.MM.yyyy"
          onChangeRaw={handleDateChangeRaw}
          filterDate={isWeekday}
          isClearable
        />
      </div>
    );
  }
}

export default Datepicker;


// WEBPACK FOOTER //
// ./src/components/Datepicker/Datepicker.js